var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a,.b,.d{fill:none;}.a,.b{stroke:#fff;stroke-width:3px;}.b{stroke-linecap:round;}.c{stroke:none;}")),React.createElement("g",{"transform":"translate(2.12)","key":1},[React.createElement("g",{"className":"a","transform":"translate(6.013)","key":0},[React.createElement("circle",{"className":"c","cx":"10.5","cy":"10.5","r":"10.5","key":0}),React.createElement("circle",{"className":"d","cx":"10.5","cy":"10.5","r":"9","key":1})]),React.createElement("path",{"className":"b","d":"M12.556,0,3.043,9.006","transform":"translate(-3.043 17.5)","key":1})])]);
}

Search.defaultProps = {"width":"29.133","height":"28.626","viewBox":"0 0 29.133 28.626"};

module.exports = Search;

Search.default = Search;
